import { IStudentVisibilitySetting } from 'api/types';
import { IRootState } from 'reducers';
import { UserSettingsState } from 'reducers/userSettings';
import { createSelector } from 'reselect';
import { configSelector } from 'selectors/common';

import { filterVisibilitySectionsByConfig } from './utils';

export const userSettingsSelector = createSelector(
  [(state: IRootState) => state.visibilitySettings, configSelector],
  (userSettings, config) => {
    if (!config) {
      const content = userSettings.content;
      const settingsState: UserSettingsState = {
        ...userSettings,
        content: content
          ? {
              ...content,
              setting: {
                visibilitySettings: [],
              },
            }
          : null,
      };

      return settingsState;
    }

    const settings = userSettings.content?.setting.visibilitySettings;
    const filteredSettings = settings ? filterVisibilitySectionsByConfig(settings, config) : undefined;

    const filteredUserSettings: UserSettingsState = {
      ...userSettings,
      content: userSettings.content
        ? {
            ...userSettings.content,
            setting: {
              visibilitySettings: filteredSettings ?? [],
            },
          }
        : null,
    };

    return filteredUserSettings;
  },
);
